export const SET_VIEWING_AUCTION = 'SET_VIEWING_AUCTION';
export const setViewingAuction = (payload: number) => ({
  type: SET_VIEWING_AUCTION,
  payload
});
